import script from "./dvhc-tinh.vue?vue&type=script&setup=true&lang=js"
export * from "./dvhc-tinh.vue?vue&type=script&setup=true&lang=js"

import "./dvhc-tinh.vue?vue&type=style&index=0&id=2d328953&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d328953"]])

export default __exports__